// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const resetPipStatuses = allowedPipTypes =>

    dispatch => {

        dispatch({
            pipStatuses: allowedPipTypes,
            type: actions.RESET_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_CRITERIA
        });

    };



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/reset-pip-statuses.js